import Facade from './facade';

export class RootSession {
  constructor() {
    this.subsessions = [];
    this.facades = [];
  }

  open() {
    let session = new Session(
      {
        onClose: () => {
          let idx = this.subsessions.findIndex((x) => x === session);
          if (idx >= 0) {
            this.subsessions.splice(idx, 1);
          }
        },
        getFacade: this.getFacade.bind(this)
      }
    );
    this.subsessions.push(session);
    return session;
  }

  use(model) {
    let facade = new Facade(model);
    this.facades.push(facade);
    this[model.name] = facade.publicMethods;
    return this;
  }

  closeSessions() {
    this.subsessions.forEach((session) => session.close());
  }

  getFacade(name) {
    return this.facades.find((facade) => name === facade.name) || (this._observer ? this._observer.getFacade(name) : null);
  }
}

export class Session extends RootSession {
  constructor(observer) {
    super();
    this._observer = observer;
    this.listeners = [];
  }

  listen(modelName, callback) {
    let name = modelName.name || modelName;
    let facade = this.getFacade(name);
    if (!facade) {
      throw new Error('Unknown model: ' + modelName);
    }

    facade.addListener(callback);
    this.listeners.push({facade, callback});
    facade.publicMethods.getState().then(callback);
    return this;
  }

  close() {
    this.subsessions.forEach((session) => session.close());
    this.listeners.forEach((item) => item.facade.removeListener(item.callback));
    this.facades.forEach((model) => model.uninit());
    this._observer.onClose();
  }
}



// WEBPACK FOOTER //
// ./modules/cliser/src/session.js